import * as React from 'react';
import {PropsWithChildren, useEffect, useRef, useState} from 'react';
import iconArrowDown from "../../assets/icons/arrow-down.svg";
import iconArrowUp from "../../assets/icons/arrow-up.svg";
import {Collapse} from "@coreui/coreui/dist/js/coreui";

interface ISidebarArea extends PropsWithChildren {
    icon: string;
    title: string;
    show: boolean;
}

export const SidebarArea: React.FC<ISidebarArea> = ({icon, title, show, children}) => {

    const content = useRef(null);
    const [collapsed, setCollapsed] = useState<boolean>(show);

    function toggleContent() {
        if (content.current) {
            new Collapse(content.current);
            setCollapsed(!collapsed);
        }
    }

    function renderAreaHeader() {
        return <h2 className="sidebar-area-header">
            <img className="icon icon-lg" src={icon} alt=""/>
            <div className="flex-fill">{title}</div>
            <img className="icon icon-lg" src={collapsed ? iconArrowUp : iconArrowDown} alt="" role="button"
                 onClick={toggleContent}/>
        </h2>;
    }

    useEffect(() => {
        if (show !== collapsed) {
            toggleContent();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    return <>
        {renderAreaHeader()}
        <div className={"collapse" + (show ? " show" : "")} ref={content}>{children}</div>
    </>;

};
export default SidebarArea;

